import { Box, Stack } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import { ConstantContext } from "components/context/ConstantProvider";
import { UserContext } from "components/context/UserProvider";
import { Form, FormContext } from "components/shared/Form";
import { buildGenericModelForm } from "components/shared/GenericModelForm";
import FormButtons from "components/ui/atoms/FormButtons";
import FormHeader from "components/ui/atoms/FormHeader";
import Highlight from "components/ui/atoms/Highlight";
import ListSelectField from "components/ui/atoms/formFields/ListSelectField";
import RHFTextField from "components/ui/atoms/formFields/RHFTextField";
import UserField from "components/ui/atoms/formFields/UserField";
import { useCreateAsyncProcesses } from "models/async_processes/apiAsyncProcesses";
import { useContext } from "react";
import * as yup from "yup";

const AsyncProcessFormHeader = ({ onClose }) => {
  const theme = useTheme();

  return (
    <FormHeader onClose={onClose}>
      <Highlight color={theme.palette_custom.yellow}>
        Start automated task
      </Highlight>
    </FormHeader>
  );
};

const validationSchema = yup.object({
  process_code: yup.string().required(),
  user_id: yup.number().required(),
});

const getInitialValues = () => {
  const { user } = useContext(UserContext);
  return {
    user_id: user.id,
  };
};

const getArgmuentsProcessFields = (processName, processList) => {
  const process = processList.find((x) => x.value === processName);

  if (!process) {
    throw new Error(`Process ${processName} is not found. Please declare it`);
  }
  return (
    process && (
      <>
        {process.args.map((arg, index) => {
          return (
            <Grid key={`p-${index}`} item mt={1} mb={1}>
              {arg.type === "text" && (
                <RHFTextField
                  name={`args.${arg.name}`}
                  label={arg.label}
                  fullWidth
                />
              )}
            </Grid>
          );
        })}
      </>
    )
  );
};

export const AsyncProcessesFormFields = () => {
  const { asyncProcessesList } = useContext(ConstantContext);

  const {
    form: { watch },
    onCancel,
  } = useContext(FormContext);

  return (
    <>
      <AsyncProcessFormHeader onClose={onCancel} />
      <Stack spacing={1} p={2} pt={"70px"}>
        <UserField name="user_id" label="Owner" disabled />
        <ListSelectField
          options={asyncProcessesList.map((x) => [x.value, x.label])}
          name="process_code"
          label="Process name"
        />
        {watch("process_code") &&
          getArgmuentsProcessFields(watch("process_code"), asyncProcessesList)}
        <Box height={80} />
      </Stack>
      <FormButtons />
    </>
  );
};

const AsyncProcessForm = (props) => {
  return (
    <Form
      validationSchema={validationSchema}
      prepareInitialValues={getInitialValues}
      {...props}
    >
      <AsyncProcessesFormFields />
    </Form>
  );
};

export const BasicModelAsyncProcessesForm = buildGenericModelForm({
  form: AsyncProcessForm,
  useCreate: useCreateAsyncProcesses,
});

export const ModelAsyncProcessesForm = (props) => {
  return <BasicModelAsyncProcessesForm {...props} />;
};
